export enum TimesheetMinimalPeriodsSource {
  MixMode = 0,
  Trip = 1,
  Gps = 2,
}
